import { action } from 'typesafe-actions';

import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';

import { AgreementListFilterActionsEnum } from '../enums/AgreementListFilterActionsEnum';
import { IAgreementListFilter } from '../interfaces/IAgreementListFilter';

export interface IAgreementListFilterSetCurrentParams {
  current?: IAgreementListFilter;
  currentId?: IFilterResult['id'];
}

export const agreementListFilterInit = () => action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_INIT);
export const agreementListFilterSetPlanNum = (planNum?: number) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_PLAN_NUM, { planNum });
export const agreementListFilterSetSwitcher = (value: boolean) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_SWITCHER, { value });
export const agreementListFilterSetCurrent = ({ current, currentId }: IAgreementListFilterSetCurrentParams) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_CURRENT, { current, currentId });
export const agreementListFilterGetMeta = () => action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_GET_META);
export const agreementListFilterSetMeta = (list: IFilterResult[]) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_META, { list });
export const agreementListFilterGetData = (id: IFilterResult['id']) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_GET_DATA, { id });
export const agreementListFilterSetData = (id: IFilterResult['id'], data: IAgreementListFilter) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_DATA, { id, data });
export const agreementListFilterCreate = (data: IAgreementListFilter) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_CREATE, { data });
export const agreementListFilterUpdate = (id: IFilterResult['id'], data: IAgreementListFilter) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_UPDATE, { id, data });
export const agreementListFilterRemove = (id: IFilterResult['id']) =>
  action(AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_REMOVE, { id });
